











































































































































































import {Component, Watch} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import StatusPicker from '@/views/reports/pickers/status-picker.vue';
import CurrencyPicker from '@/views/dashboard/pickers/currency-picker.vue';
import { forceCleanCache } from '@/services/utils/websocket';
import PeriodPicker from '@/views/reports/pickers/period-picker.vue';
import SortBy from '@/views/dashboard/pickers/sort-by.vue';
import Direction from '@/views/dashboard/pickers/direction.vue';
import LoadingCircle from '@/components/loading-circle.vue';
import Chart from '@/views/dashboard/config/chart.vue';
import dashboard_options from '@/views/dashboard/config/dashboard-options';
import stats_options from '@/views/dashboard/config/stats-options';

import ReportBase from './reports/report-base';

import ReportAPI from '@/services/rest/bemob/report';
import userSettingsApi from '@/views/settings/general/api';
import { debounce, cloneDeep, pick, omit } from 'lodash';
import { pushURL } from './dashboard/pickers/base/utils';
import CurrencyMixin from '@/components/helpers/currency-mixin';

const md5 = require('md5');

@Component({
  components: {
    Chart,
    StatusPicker,
    CurrencyPicker,
    PeriodPicker,
    SortBy,
    Direction,
    LoadingCircle
  }
})
export default class Home extends mixins(ReportBase, CurrencyMixin,Chart) {
  chartColumns: string[] =  [
    'reports-impressions',
    'reports-visits',
    'reports-clicks',
    'reports-conversions',
    'reports-conversionconfirm',
    'reports-revenue',
    'reports-cost',
    'reports-profit',
    'reports-hiddenprofit',
    'reports-hiddenrevenue',
    'reports-conversionconfirmhiddenrevenue'
  ];
  dashboardData: any = dashboard_options(this);
  statisticsData = stats_options(this);
  chartReady = false;
  currencyIcon = '';
  error: boolean = false;

  get isCurrencyOrderBy() {
    return this.orderBy === 'reports-profit'
      || this.orderBy === 'reports-revenue'
      || this.orderBy === 'reports-cost';
  }

  @Watch('$route.name', { immediate: true })
  onRouteName(value: string, oldValue: string) {
    if(value !== oldValue) {
      if(value === 'app.index') {
        this.$nextTick(() => {
          this.getReports()
        });
      } else if(value === 'app.blank') {
        this.$router.replace(this.defaultHomepage());
      }
    }
  }

  mounted() {
    this.$store.commit('restoreDashboardQuery');

    this.bus.on('refresh-dashboard', this.onBusRefreshDashboard);

    this.resetDashboardParams();
  }

  beforeDestroy() {
    this.bus.off('refresh-dashboard', this.onBusRefreshDashboard);
  }

  created() {
    if (this.$route.query.resetSelectedReport === 'true')
      this.$store.commit('tableSelectedReport', null);
  }

  onBusRefreshDashboard()  {
    this.resetDashboardParams();
    this.getReports();
  }

  getDashboardChart() {
    this.chartOptions = JSON.parse(JSON.stringify(this.initialChartOptions));
    const params = {
      ...this.$store.state.dashboard.queryTemporary,
      groupBy: 'campaigns',
      columns: this.chartColumns,
    };

    const {selectedWorkspaces, workspaces} = this.$store.state.user;
    if(selectedWorkspaces?.length===workspaces?.length){
      delete params.workspaceIds
    }else{
      params.workspaceIds = selectedWorkspaces;
    }

    return new ReportAPI()
      .getAggregatedReport(this.aggregatedValue, params)
      .then((e: any) => {
        this.handleChartResponse({
          data:e.data.payload.data,
          isCompare:false
        })
        this.chartReady = true;
      })
      .catch((error: any) => {
        this.error = true;
      });
  }

  getDashboardReport(group: string) {
    const columns = [this.$store.state.dashboard.queryTemporary.orderBy];

    switch (group) {
      case 'traffic-sources':
        columns.push('traffic_sources-name');
        break;
      case 'countries':
        columns.push('reports-country');
        break;
      case 'campaigns':
        columns.push('campaigns-name');
        break;
      case 'offers':
        columns.push('offers-name');
        break;
    }

    const params = {
      ...this.$store.state.dashboard.queryTemporary,
      groupBy: group,
      formatResponse: 1,
      columns,
      limit: 5,
      offset: 0,
      workspaceIds:this.$store.state.user.selectedWorkspaces
    };

    return new ReportAPI()
      .getReport(params)
      .then((e: any) => {
        const item = this.dashboardData.find((e: any) => group === e.value);
        item.data = e.data.payload.data;
      })
      .catch((error: any) => {
        this.error = true;
        return Promise.reject(error);
      });
  }

  getDashboardStatistics() {
    const columns = this.statisticsData.map(e => e.name);

    const params = {
      ...this.$store.state.dashboard.queryTemporary,
      groupBy: 'campaigns',
      formatResponse: 0,
      columns: columns,
      orderBy: 'reports-visits',
      limit: 50,
      offset: 0,
    };

    const {selectedWorkspaces, workspaces} = this.$store.state.user;
    if(selectedWorkspaces?.length===workspaces?.length){
      delete params.workspaceIds
    }else{
      params.workspaceIds = selectedWorkspaces;
    }
    return new ReportAPI().getReport(params);
  }

  handleRefreshApply(){
    if(!this.isParamsChanged) forceCleanCache();
    this.$store.commit('applyDashboardQuery');
    pushURL(this);
    this.getReports(this.isParamsChanged);
  }

  getReports(saveUser: boolean = false) {
    const { commit } = this.$store;
    commit('loading', true);

    const stats: Promise<any> = this.getDashboardStatistics();
    //const chart: PromiseLike<any> = this.getDashboardChart();
    const reports: Promise<any> = Promise.all(this.dashboardData.map((e: any) => {
      return this.getDashboardReport(e.value);
    }));

    if(saveUser) {
      let {orderBy, orderDir} = this.$store.state.dashboard.query;
      let to_save = orderBy.replace('reports-','');
      if (to_save.includes('conversion'))
        to_save = 'conversions';

      userSettingsApi.put({
        dashboardDefaultOrderDir: orderDir,
        dashboardDefaultGroup: to_save,
      })
      .then((user: any)=>{
        this.$store.commit('updateUser', user);
      });
    }

    let totals: any = null;

    return Promise.all([stats, reports])
      .then((data: any[]) => {
        totals = data[0].data.payload.total;

        this.resetDashboardParams();
        return this.getDashboardChart();
      })
      .finally(() => {
        if(totals) {
          this.statisticsData.forEach((e: any) => {
            e.value = totals[e.name];
          });
        }

        const { query } = this.$store.state.dashboard;
        this.currencyIcon = this.currencies[query.currency];

        commit('loading', false);
      });
  }

  oldDashboardParams = this.currentDashboardParams;

  resetDashboardParams() {
    this.oldDashboardParams = this.currentDashboardParams;
    this.oldHash = this.getCurrentHash();
  }

  get isParamsChanged() {
    return this.oldHash !== this.getCurrentHash();
  }

  get currentDashboardParams() {
    return cloneDeep({
      dashboardQuery: pick(this.$store.state.dashboard.queryTemporary, this.filterParams),
      dashboardSortBy: this.$store.state.dashboard.sortBy
    });
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.currentDashboardParams));
  }

  get filterParams() {
    return ['from', 'to', 'status', 'currency', 'orderBy', 'orderDir'];
  }

  get loadingState() {
    return this.$store.state.isLoading;
  }

  get orderBy() {
    return this.oldDashboardParams.dashboardQuery.orderBy;
  }

  get sorting() {
    return this.oldDashboardParams.dashboardSortBy;
  }

  select: any = null;
  profitClass(item: any) {
    if (item['reports-profit'] > 0)
    {
      return 'success';
    }
    else if (item['reports-profit'] < 0)
    {
      return 'danger';
    }
    else
    {
      return 'secondary';
    }
  }

  get miniDashboardClassAffected() {
    return [ 'reports-roi', 'reports-profit' ]
  }

  miniDashboardClass(val: string | number, type: string) {
    if(type && !this.miniDashboardClassAffected.includes(type)) {
      return '';
    }

    if (val > 0) {
      return 'success';
    } else if (val < 0) {
      return 'danger';
    }
  }
}
